import React from 'react'

import { SHIPMENT_STATUS, SHIPMENT_STATUS_TO_LMD_DISPLAY_STATUS } from '@fielded/fs-api/lib/shipment/constants'

import GoodsTransferProgressInfo from '../../../../../../van-shared/components/GoodsTransferProgressInfo'

const LMDDeliveryDetailTransferInfo = ({
  delivery
}) => {
  const VISIBLE_STATUS_LIST = [
    SHIPMENT_STATUS.NEW,
    SHIPMENT_STATUS.PACKED,
    SHIPMENT_STATUS.SENT,
    SHIPMENT_STATUS.ARRIVED,
    SHIPMENT_STATUS.RECEIVED
  ]

  const baseUrl = '/shipments/last-mile-deliveries'

  return (
    <GoodsTransferProgressInfo
      snapshotsList={delivery.snapshotDates}
      statusList={VISIBLE_STATUS_LIST}
      statusListLabels={SHIPMENT_STATUS_TO_LMD_DISPLAY_STATUS}
      linksConfig={{
        [SHIPMENT_STATUS.SENT]: {
          label: 'Package note',
          path: `${baseUrl}/package-note/${delivery.snapshotId}`,
          displayCondition: 'inProgressOrCompleted'
        },
        [SHIPMENT_STATUS.RECEIVED]: {
          label: 'Delivery note',
          path: `${baseUrl}/delivery-statement/${delivery.snapshotId}`,
          displayCondition: 'completed'
        }
      }}
    />
  )
}

export default LMDDeliveryDetailTransferInfo
